export enum ModalTypes {
  CANDIDATE_INFO_FIELD_MODAL,
  ADD_TRAIT_MODAL,
  EDIT_TRAIT_MODAL,
  STATIC_CONTENT_FILTERS_MODAL,
  TEXT_FIELD_MODAL,
  WARNING_MODAL,
  REPORTS_PAGE_MODAL,
  ADD_WIDGET_OPTION_MODAL,
  ADD_WIDGET_MODAL,
  WIDGET_CONFIG_MODAL,
  ADD_NEW_USER_ROLE_MODAL,
  ADD_NEW_USER_MODAL,
  EDIT_USER_MODAL,
  ADD_COMPANY_SIGNATURE_MODAL,
  CONFIRMATION_MODAL,
  LANGUAGE_MODAL,
  STAGE_INDIRECT_INVITATION_MODAL,
  MITIGATE_CIRCUMSTANCE_MODAL,
  STYLED_CONFIRMATION_MODAL,
  NOTIFICATION_MODAL,
  COMPANY_EMPLOYEE_MODAL,
  EDIT_HR_MANAGER_EMPLOYEE_ID_MODAL,
  BEHAVIOUR_CONTENT_MODAL,
  DELETE_ASSESSMENT_MODAL,
  EDIT_DEI_ACTION,
  REPORTS_ACCESS,
  UPDATE_COGNITIVE_TESTS_BLOCKED,
  UPLOAD_INTERVIEW_QUESTION_CSV_MODAL,
  UPLOAD_SOFT_SKILLS_CONTENT_CSV_MODAL,
  DOWNLOAD_SOFT_SKILLS_CONTENT_CSV_MODAL,
  UPLOAD_TRAIT_CONTENT_CSV_MODAL,
}
